<template>
  <button type="button" class="btn" :disabled="disabled" @click="disabled || emit('click')">
    <component
      stroke-width="1.5"
      :is="icon"
      v-if="icon && iconPos === 'start'"
      :class="{ 'me-2': hasSlotContent }"
      :size="iconSize" />
    <slot></slot>
    <component
      stroke-width="1.5"
      :is="icon"
      v-if="icon && iconPos === 'end'"
      :class="{ 'ms-2': hasSlotContent }"
      :size="iconSize" />
  </button>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';

export interface Props {
  icon?: any;
  iconPos?: 'start' | 'end';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  iconPos: 'end',
  size: 'md',
  disabled: false,
});

const slots = useSlots();
const hasSlotContent = computed(() => !!slots.default);
const iconSizeMap: Record<string, number> = { sm: 13, md: 18, lg: 22, xl: 26 };
const iconSize = computed(() => iconSizeMap[props.size]);

const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>
